import { render, staticRenderFns } from "./ExportWorkingDraftHelp.vue?vue&type=template&id=2d0c5aaa&scoped=true"
import script from "./ExportWorkingDraftHelp.vue?vue&type=script&lang=js"
export * from "./ExportWorkingDraftHelp.vue?vue&type=script&lang=js"
import style0 from "./ExportWorkingDraftHelp.vue?vue&type=style&index=0&id=2d0c5aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c5aaa",
  null
  
)

export default component.exports